module.exports = __webpack_public_path__ + "static/img/areaB_05.55f8b09.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_05.png
// module id = 1257
// module chunks = 1